const tables = [
  {
    name: "Name",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
